export const discountCategory = {
	title: "Categorías de Descuentos",
	label: "Cree, edite, elimine, active o desactive categorías de descuento",
	search: {
		label: "Buscar",
		placeholder: "Buscar nombre de la categoría de descuento",
	},
	filter: {
		label: "Filtrar por",
		placeholder: "Elegir filtro",
	},
	create: "Crear nueva categoría",
	allCategories: "Todas las categorías de descuento",
	activeCategories: "Categorías de descuento activas",
	inactiveCategories: "Categorías de descuento inactivas",
	errorNotification: "Seleccione un local primero",
	drawer: {
		edit: "Editar categoría de descuento",
		create: "Crear categoría de descuento",
	},
	form: {
		name: {
			label: "Nombre de la categoría",
			placeholder: "Dé un nombre a la categoría de descuento",
		},
		discount: {
			label: "Descuento dado en",
			value: "Pesos",
			percentage: "Porcentaje",
		},
		estabilishedType: {
			label: "Establecido",
			fixed: "Valor fijo",
			range: "Rango",
		},
		employees: {
			label: "Empleados autorizados a utilizar la categoría",
			placeholder: "Busque por nombre",
		},
		between: "Entre",
		and: "y",
		errors: {
			name: "Ingrese un nombre válido",
			estabilishedType: "Seleccione una opción arriba",
			employees: "Seleccione un empleado",
		},
		observation: "Observaciones",
		addObservation: "Permitir agregar observación",
	},
	modal: {
		title: "Eliminar categoría de descuento",
		message: "¿Desea eliminar la categoría de '{{name}}'?",
	},
	table: {
		status: "ESTADO",
		name: "NOMBRE DE LA CATEGORÍA DE DESCUENTO",
		discountType: "DESCUENTO DADO EN",
		value: "RANGO O VALOR FIJO",
		showEmployees: "Visualizar empleados con permiso",
		hideEmployees: "Ocultar empleados con permiso",
		emptyText: "Parece que aún no ha creado una categoría de descuento",
		editCategory: "Editar categoría de descuento",
		removeCategory: "Eliminar categoría de descuento",
		employee: "Empleado con Permiso",
		loading: "Cargando",
	},
};
